import { defineComponent as c, ref as l, onServerPrefetch as o, onMounted as f, watch as u, h as s } from "vue";
import { extractRootHtmlElement as m } from "@scalar-org/vue-render";
import { resolveAndFetchIcon as r } from "./resolveAndFetchIcon.js";
function h(e) {
  e.target instanceof HTMLElement && (e.target.style.visibility = "hidden");
}
const w = c({
  props: ["src", "title", "mask"],
  setup(e) {
    const i = l(), n = (t) => typeof t == "string" ? t : t.src || "";
    return o(async () => {
      i.value = await r(n(e.src));
    }), f(async () => {
      i.value || (i.value = await r(n(e.src)));
    }), u(
      () => e.src,
      async (t) => {
        const a = await r(n(t));
        a && a !== i.value && (i.value = a);
      }
    ), () => {
      if (i.value) {
        const t = m(i.value);
        if (t.tagName === "svg")
          return s(t.tagName, {
            ...t.properties,
            width: e.size,
            height: e.size,
            class: { ...t.properties.class, ...e.classes },
            innerHTML: t.innerHTML
          });
      }
      return s("img", {
        src: e.src,
        alt: e.title,
        width: e.size,
        height: e.size,
        style: "object-fit: contain;",
        class: e.classes,
        onError: h
      });
    };
  }
});
export {
  w as GuideIcon
};
